import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '@/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
  },
  {
    path: '/contacts',
    component: () =>
      import(/* webpackChunkName: "contact" */ '@/views/pages/Contacts.vue')
  },
  {
    path: '/products',
    component: () =>
      import(
        /* webpackChunkName: "products" */ '@/views/pages/products/Products.vue'
      )
  },
  {
    path: '/products/:slug',
    component: () =>
      import(
        /* webpackChunkName: "singleProduct" */ '@/views/pages/products/Product.vue'
      ),
    meta: { layout: 'secondary', className: 'background-grey' }
  },
  {
    path: '/partners',
    component: () =>
      import(
        /* webpackChunkName: "partners" */ '@/views/pages/partners/Partners.vue'
      ),
    meta: { layout: 'secondary' }
  },
  {
    path: '/partners/:id',
    component: () =>
      import(
        /* webpackChunkName: "singlePartner" */ '@/views/pages/partners/Partner.vue'
      ),
    meta: { layout: 'secondary' }
  },
  // {
  //   path: '/blog',
  //   component: () =>
  //     import(/* webpackChunkName: "blog" */ '@/views/pages/blog/blogs.vue'),
  //   meta: { layout: 'secondary' }
  // },
  // {
  //   path: '/blog/:id',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "singleBlog" */ '@/views/pages/blog/singleBlog.vue'
  //     ),
  //   meta: { layout: 'secondary' }
  // },
  // {
  //   path: '/calculator',
  //   component: () =>
  //     import(/* webpackChunkName: "calculator" */ '@/views/pages/calculator'),
  //   meta: { layout: 'secondary', className: 'calculator' }
  // },
  {
    path: '/gallery',
    component: () =>
      import(/* webpackChunkName: "gallery" */ '@/views/pages/gallery'),
    redirect: '/gallery/photos',
    meta: { layout: 'secondary' },
    children: [
      {
        path: 'photos',
        component: () => import('@/views/pages/gallery/photo/Photos.vue'),
        meta: { layout: 'secondary' }
      },
      {
        path: 'photos/:id',
        component: () =>
          import(
            /* webpackChunkName: "galleryPhotos" */ '@/views/pages/gallery/photo/Photo.vue'
          ),
        meta: { layout: 'secondary' }
      },
      {
        path: 'video',
        component: () =>
          import(
            /* webpackChunkName: "galleryVideos" */ '@/views/pages/gallery/Video.vue'
          ),
        meta: { layout: 'secondary' }
      }
    ]
  },
  {
    path: '/about',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/pages/about'),
    redirect: '/about/company',
    children: [
      {
        path: 'company',
        component: () =>
          import(
            /* webpackChunkName: "aboutCompany" */ '@/views/pages/about/Company.vue'
          )
      },
      {
        path: 'how-to-buy',
        component: () =>
          import(
            /* webpackChunkName: "aboutHowToBuy" */ '@/views/pages/about/HowToBuy.vue'
          ),
        meta: { layout: 'secondary' }
      },
      {
        path: 'delivery',
        component: () =>
          import(
            /* webpackChunkName: "aboutDelivery" */ '@/views/pages/about/Delivery.vue'
          ),
        meta: { layout: 'secondary' }
      },
      // {
      //   path: 'work',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "aboutWork" */ '@/views/pages/about/Work/Work.vue'
      //     ),
      //   meta: { layout: 'secondary' }
      // },
      // {
      //   path: 'work/:id',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "aboutSingleWork" */ '@/views/pages/about/Work/SingleWork.vue'
      //     ),
      //   meta: { layout: 'secondary' }
      // },
      // {
      //   path: 'door-installation',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "aboutDoorInstallation" */ '@/views/pages/about/DoorInstallation.vue'
      //     ),
      //   meta: { layout: 'secondary' }
      // },
      {
        path: 'pages/:id',
        component: () =>
          import(
            /* webpackChunkName: "aboutDynamicPages" */ '@/views/pages/about/page'
          ),
        meta: { layout: 'secondary' }
      }
    ]
  },
  {
    path: '/user',
    component: () =>
      import(/* webpackChunkName: "user" */ '@/views/pages/user'),
    meta: { layout: 'secondary' },
    beforeEnter: (to, _from, next) => {
      const isValid = () => getToken() !== null
      if (!isValid()) {
        next('/auth/login')
      }
      next()
    }
  },
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/auth'),
    meta: { layout: 'secondary' },
    beforeEnter: (to, _from, next) => {
      const isValid = () => getToken() !== null
      if (isValid()) {
        next('/')
      }
      next()
    },
    redirect: '/auth/login',
    children: [
      {
        path: 'register',
        component: () =>
          import(
            /* webpackChunkName: "authRegister" */ '@/views/auth/Register.vue'
          ),
        meta: { layout: 'secondary' }
      },
      {
        path: 'login',
        component: () =>
          import(/* webpackChunkName: "authLogin" */ '@/views/auth/Login.vue'),
        meta: { layout: 'secondary' }
      }
    ]
  },
  {
    path: '/error',
    component: () =>
      import(/* webpackChunkName: "error" */ '@/views/Error.vue'),
    meta: { layout: 'empty' }
  },
  {
    path: '*',
    component: () =>
      import(/* webpackChunkName: "error" */ '@/views/Error.vue'),
    meta: { layout: 'empty' }
  }
]

const router = new VueRouter({
  linkActiveClass: 'router-link-active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
